import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonDirective, ButtonLoadingDirective, IconComponent } from '@ion-ui/atoms';
import { TranslateModule } from '@ngx-translate/core';
import { TuiPopover, tuiPure } from '@taiga-ui/cdk';
import { TUI_DIALOGS_CLOSE, TuiNotification } from '@taiga-ui/core';
import { TuiCheckbox } from '@taiga-ui/kit';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { Observable } from 'rxjs';

import { ConfirmationModalOptions } from './confirmation-modal-options.model';

@Component({
  selector: 'ion-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    // own custom components
    ButtonDirective,
    ButtonLoadingDirective,
    IconComponent,
    // taiga ui components
    TuiNotification,
    TuiCheckbox,
  ],
})
export class ConfirmationModalComponent {
  readonly context = inject<TuiPopover<ConfirmationModalOptions, boolean>>(POLYMORPHEUS_CONTEXT);

  confirmed = false;
  readonly confirmationCheckboxId = 'confirmation-checkbox';
  readonly confirmationLabelId = `${this.confirmationCheckboxId}-label`;
  readonly confirmationDescriptionId = `${this.confirmationCheckboxId}-description`;

  constructor() {
    const close$ = inject<Observable<unknown>>(TUI_DIALOGS_CLOSE);

    close$.subscribe(() => {
      this.cancel();
    });
  }

  confirm(): void {
    if (this.context.doCompleteOnConfirm) {
      this.context.completeWith(true);
    } else {
      this.context.$implicit.next(true);
    }
  }

  cancel(): void {
    this.context.completeWith(false);
  }

  @tuiPure
  getKeyValueList() {
    if (this.context.keyValueList) {
      const entries = Object.entries(this.context.keyValueList);
      if (entries.length > 0) return entries;
    }
    return null;
  }
}
